module.exports = __webpack_public_path__ + "img/stripe_logo.5581909a.svg";